import { Input, Component, forwardRef, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { NumberFieldModel } from '../../../models/number-field.model';
import { AbstractFormFieldComponent } from '../../FormField/abstract-form-field.component';

@Component({
    selector: 'agpr-number-field',
    templateUrl: './number-field.component.html',
    styleUrls: ['./number-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => NumberFieldComponent)
        }
    ],
    standalone: false
})
export class NumberFieldComponent extends AbstractFormFieldComponent implements OnChanges, AfterViewInit {

    @Input() declare field: NumberFieldModel;

    showField: boolean = true;

    ngOnChanges(changes: SimpleChanges): void {
        if (this.field?.appearCondition) {
            this.showField = this.field.appearCondition(this.block);
        }
    }

    inputChange(num) {
        this.value = num;
        if (this.field.max && num > this.field.max) {
            this.value = this.field.max;
        }
        if (this.field.min && num < this.field.min) {
            this.value = this.field.min;
        }

        this.changes.emit(this.value);
    }

    ngAfterViewInit(): void {
        // should only run for briefing mention blocks..
        if (this.field.appearCondition) {
            this.showField = this.field.appearCondition(this.block);
        }
    }
}
